import { useContext, useMemo } from "react";
import { AppContext } from "context/appContext";

const useColors = () => {
  const { state } = useContext(AppContext);

  const colors = useMemo(() => {
    return state.colors;
  }, [state.colors]);

  return colors;
};

export default useColors;
